import { defineMessages } from 'react-intl';

const messages = defineMessages({
  text: {
    description: 'Sign in gate text',
    defaultMessage: 'Sign in required to protect younger audiences. No credit card needed.',
  },
});

export default messages;
